export const PAYOUT = 'PAYOUT';
export const PAYOUT_ALL = `${PAYOUT}/ALL`;
export const PAYOUT_BY_ID = `${PAYOUT}/BY_ID`;
export const PAYOUT_SEARCH = `${PAYOUT}/SEARCH`;
export const PAYOUT_EXPORT = `${PAYOUT}/EXPORT`;
export const PAYOUT_TRANSACTIONS_EXPORT = `${PAYOUT}/TRANSACTIONS_EXPORT`;
export const PAYOUT_TRANSFERS = `${PAYOUT}/TRANSFERS`;
export const PAYOUT_WEBHOOKS = `${PAYOUT}/WEBHOOKS`;
